<template>
  <h4 style="font-size: 12px; color: #10425A">
    <span>
      Search
      <v-icon style="font-size: 14px;">search</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <input
        class="search"
        :id="'search'+table"
        v-on:keyup="search(table)"
        style="width: 50%;"
        type="text"
        placeholder="Type anything related to the booking"
      />
    </span>
  </h4>
</template>

<script>
export default {
  name: "table_search",
  props: {
    table: String
  },
  methods: {
    searchTable: function() {
      this.search(this.table);
    },
    search: function(table) {
      // console.log("Search called");

      var input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("search" + this.table);

      // console.log("search " + input.value);

      filter = input.value.toUpperCase();
      table = document.getElementById(table);
      tr = table.getElementsByTagName("tr");

      var headerName = this.table + "-header-row";

      // Loop through all table rows, and hide those who don't match the search query
      for (i = 0; i < tr.length; i++) {
        // td = tr[i].getElementsByTagName("td")[0];
        let td = tr[i];
        if (td && td.id != headerName) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            td.style.display = "";
          } else {
            td.style.display = "none";
          }
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#gridcontainer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}

#searchcontainer {
  position: absolute;
  width: 100%;
  height: 24px;
  bottom: 0px;
  left: 0;
  padding-top: 1px;
  padding-left: 24px;
  right: 0;
  background-color: #f5f5f5;
}

.upcoming-table {
  font-size: 11px;
}

th {
  text-align: left;
  color: #10425a;
}

th,
td {
  text-align: left;
  padding-left: 8px;
}

td {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

table {
  padding: 4px;
  border-collapse: collapse;
}

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}

.search {
  outline: none;
}
</style>
